import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04e63aaf"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "download"
}




export default /*#__PURE__*/_defineComponent({
  emits: ["downloadCanvas"],
  setup(__props, { emit }: { emit: ({
  (e: "downloadCanvas"): void;
}), expose: any, slots: any, attrs: any }) {



return (_ctx: any,_cache: any) => {
  return true
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('downloadCanvas')))
        }, "Download")
      ]))
    : _createCommentVNode("", true)
}
}

})